export const ESTUDIANTE_FORM = 'https://forms.gle/rZYUEfiYXafebR929';
export const DOCENTE_FORM = 'https://forms.gle/AXMReC11hc8HT7xZA';
